import request from '@/utils/request'

// 奖票
/**
 * 未使用列表接口
 */
export function getUnusedRaffleTicketList() {
    return request.post("/marketing/raffleTicket/getUnusedRaffleTicketList")
}

/**
 * 已使用列表接口
 */
export function getUsedRaffleTicketList() {
    return request.post("/marketing/raffleTicket/getUsedRaffleTicketList")
}

/**
* 已过期列表接口
*/
export function getExpireRaffleTicketList() {
    return request.post("/marketing/raffleTicket/getExpireRaffleTicketList")
}

/**
 * 抽奖接口
 */
export function lottery(id) {
    return request.post("/marketing/raffleTicket/lottery",
        { id: id })
}

/**
 * 获取我的红包列表
 * @returns 
 */
export function getNewYearActivityList() {
    return request.post("/marketing/newYearActivity/redPacket");
}

/**
 * 我的红包开奖
 * @param {*} id 
 */
export function operationRedPacket(id) {
    return request.post("/marketing/newYearActivity/operationRedPacket", { id: id })
}

/**
 * 是否有红包未开奖
 * @returns 
 */
export function unOperation() {
    return request.post("/marketing/newYearActivity/unOperation")
}